import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import TriageWizard from "@/components/triage/TriageWizard";
import TriageIntroModal from "@/components/triage/TriageIntroModal";

export default function TriagePage() {
  const [searchParams] = useSearchParams();
  const [showIntro, setShowIntro] = useState(false);

  // Show intro modal only for new sessions (no sessionId param) and if not skipped permanently
  useEffect(() => {
    const sessionId = searchParams.get("sessionId");
    const hasSeenIntro = sessionStorage.getItem("triage_intro_seen");
    const skipIntroPermanently = localStorage.getItem("triage_intro_skip");
    
    if (!sessionId && !hasSeenIntro && !skipIntroPermanently) {
      setShowIntro(true);
    }
  }, [searchParams]);

  const handleStartAssessment = () => {
    sessionStorage.setItem("triage_intro_seen", "true");
    setShowIntro(false);
  };

  const handleSkipIntro = () => {
    // Permanently skip intro for this user
    localStorage.setItem("triage_intro_skip", "true");
    sessionStorage.setItem("triage_intro_seen", "true");
    setShowIntro(false);
  };

  return (
    <>
      <Helmet>
        <title>AI Symptom Checker - Smart Health Assessment | CheckFirst</title>
        <meta name="description" content="Use our AI-powered symptom checker and smart health assessment. Get instant healthcare guidance with our clinical decision support algorithm. AI-driven recommendations for better care." />
        <meta name="keywords" content="AI symptom checker for hospitals, AI algorithm healthcare, smart health assessment, clinical decision support tool, AI healthcare platform, patient assessment platform" />
        
        <meta property="og:title" content="AI Symptom Checker - Smart Health Assessment" />
        <meta property="og:description" content="Use our AI algorithm-powered symptom checker for smart health assessment. Clinical decision support with instant healthcare guidance." />
        <meta property="og:url" content="https://www.checkfirstcare.com/triage" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.checkfirstcare.com/og-image.jpg" />
        
        <meta name="twitter:title" content="AI Symptom Checker - Smart Health Assessment" />
        <meta name="twitter:description" content="Use our AI algorithm-powered symptom checker for smart health assessment. Clinical decision support with instant healthcare guidance." />
        
        <link rel="canonical" href="https://www.checkfirstcare.com/triage" />
      </Helmet>
      
      <TriageIntroModal open={showIntro} onStart={handleStartAssessment} onSkip={handleSkipIntro} />
      <TriageWizard />
    </>
  );
}